import React, { forwardRef, Ref } from "react";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

export interface TextAreaProps {
    autofocus?: boolean;
    disabled?: boolean;
    id: string;
    maxLength?: number;
    name?: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onInput?: () => void;
    onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    ref?: Ref<HTMLTextAreaElement>;
    rows?: number;
    spellcheck?: boolean;
    cssClassName?: string;

    /**
     * Unique identifier used select the underlying <textarea> for functional/e2e testing
     */
    testId?: string;
    value?: string;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const TextArea = forwardRef(
    (props: TextAreaProps, ref: Ref<HTMLTextAreaElement>) => {
        const {
            autofocus = false,
            disabled,
            id,
            maxLength,
            name,
            onBlur,
            onChange,
            onInput,
            onKeyDown,
            placeholder,
            rows,
            testId,
            value,
            spellcheck,
            cssClassName = "",
        } = props;

        return (
            <textarea
                className={cssClassName}
                data-test-id={testId}
                autoFocus={autofocus}
                disabled={disabled}
                id={id}
                maxLength={maxLength}
                name={name}
                onChange={onChange}
                onInput={onInput}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                ref={ref}
                rows={rows}
                value={value}
                spellCheck={spellcheck}
            />
        );
    }
);

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default TextArea;

// #endregion Exports
